import "./styles/wm.css";

const WorthMentioning = () => {
  const worthmentioning = [
    {
      content: 'Served as the charter SAA (Surgent At Arms) of <a href="https://www.linkedin.com/company/malindi-toastmasters/" target="_blank">Malindi Toastmasters Club</a>',
      date: "Feb 2026",
      tag: "Leadership",
    },
    {
      content: 'Became a charter member of the <a href="https://www.linkedin.com/company/malindi-toastmasters/" target="_blank">Malindi Toastmasters Club</a>',
      date: "Mar 2026",
      tag: "Public Speaking",
    },
    {
      content: "Graduated from <a href='https://www.kamilimu.org/' target='_blank'>KamiLimu</a> mentorship program, also won the 2025 KamiLimu public speaking competition",
      date: "Dec 2025",
      tag: "Award",
    },
    {
      content: 'Graduated from <a href="https://www.mut.ac.ke/" target="_blank">Murang\'a University of Technology</a> with a degree in Bachelor\'s of Science in Software Engineering',
      date: "Aug 2025",
      tag: "Education",
    },
    {
      content: 'Accepted and started the cohort 9 of the <a href="https://www.kamilimu.org/" target="_blank">KamiLimu</a> mentorship program',
      date: "Mar 2025",
      tag: "Mentorship",
    },
  ];

  return (
    <div className="wm-section">
      <h2 className="section-title wm-heading">Worth Mentioning</h2>
      <div className="wm-timeline">
        {worthmentioning.map((item, index) => (
          <div className="wm-item" key={index}>
            <div className="wm-date">{item.date}</div>
            <div className="wm-gutter">
              <div className="wm-dot" />
              <div className="wm-line" />
            </div>
            <div className="wm-content">
              <div
                className="wm-text"
                dangerouslySetInnerHTML={{ __html: item.content }}
              />
              <span className="wm-tag">{item.tag}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorthMentioning;